<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :status="item.status"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import exdateChangeMain from "@/pages/review/exdate-change/exdate-change-main"
const systemDate = window.sessionStorage.getItem('systemDate') || new Date();
export default {
  components: {
    exdateChangeMain
  },
  name: "exdate-change",
  data() {
    return {
      tabData: [
        {
          name: "待复核",
          key: "review",
          comp: exdateChangeMain,
          status: "0",
        },
        {
          name: "复核记录",
          key: "records",
          comp: exdateChangeMain,
          status: "1,2"
        }
      ],
      tabCur: "review"
    }
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"

    })
  },
  created() {
  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/review/exdate-change/exdate-change.vue